import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

const links = [
  { label: "Sobre", id: "sobre" },
  { label: "Serviços", id: "servicos" },
  { label: "Abordagem", id: "abordagem" },
  { label: "Testemunhos", id: "testemunhos" },
  { label: "Contacto", id: "contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const SITE = useContent();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/#" + id);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-b border-rose-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-display text-2xl tracking-tight text-stone-900">
          {SITE.name}
          <span className="text-rose-700">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="link-underline text-sm text-stone-600 hover:text-stone-900"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/marcacao"
            data-testid="nav-book-btn"
            className="btn-rose hidden sm:inline-flex items-center rounded-full bg-rose-800 text-white text-sm px-6 py-3"
          >
            Marcar consulta
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden text-stone-800"
            aria-label="Menu"
          >
            <span className="block w-6 h-px bg-current mb-1.5" />
            <span className="block w-6 h-px bg-current" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-rose-100 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-stone-700"
            >
              {l.label}
            </button>
          ))}
          <Link to="/marcacao" className="mt-2 rounded-full bg-rose-800 text-white text-center px-6 py-3">
            Marcar consulta
          </Link>
        </div>
      )}
    </header>
  );
};
